function redirectRoute(to, from, next) {
  const permissions = localStorage.userPermissions.split(",");
  const permission = permissions.find(item => item === to.meta.permissions);
  if (permission) {
    next();
  } else if (!permission && to.params.id > 0) {
    next();
  } else {
    next("/dashboard");
  }
}
export default redirectRoute;